(() => {
  const initializeHeaders = (scope = document) => {
    scope.querySelectorAll('[data-marmelade-header]').forEach((shell) => {
      if (shell.dataset.headerInteractive === 'true') return;
      const toggle = shell.querySelector('[data-header-menu-toggle]');
      const menu = shell.querySelector('[data-header-menu]');
      const cart = shell.querySelector('[data-marmelade-cart-open]');
      const desktopShop = shell.querySelector('[data-desktop-shop]');
      const desktopShopToggle = shell.querySelector('[data-desktop-shop-toggle]');
      const desktopShopMenu = shell.querySelector('[data-desktop-shop-menu]');
      if (!toggle || !menu) return;
      shell.dataset.headerInteractive = 'true';
      let closeTimer;
      let isolationRecords = [];
      const openLabel = toggle.getAttribute('aria-label');
      const closeLabel = shell.dataset.closeMenuLabel;

      const rememberAndIsolate = (element) => {
        isolationRecords.push({
          element,
          inert: element.inert,
          ariaHidden: element.getAttribute('aria-hidden'),
        });
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      };

      const isolateBackground = () => {
        if (isolationRecords.length) return;
        shell.querySelectorAll('.marmelade-header > *').forEach((element) => {
          if (![toggle, cart].some((control) => control && (element === control || element.contains(control)))) {
            rememberAndIsolate(element);
          }
        });
        let current = shell;
        while (current && current !== document.body) {
          const parent = current.parentElement;
          if (!parent) break;
          Array.from(parent.children).forEach((sibling) => {
            if (sibling !== current) rememberAndIsolate(sibling);
          });
          current = parent;
        }
      };

      const restoreBackground = () => {
        isolationRecords.forEach(({ element, inert, ariaHidden }) => {
          element.inert = inert;
          if (ariaHidden === null) element.removeAttribute('aria-hidden');
          else element.setAttribute('aria-hidden', ariaHidden);
        });
        isolationRecords = [];
      };

      const getFocusableElements = () => [toggle, cart, ...menu.querySelectorAll(
        'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => (
        element && !element.hidden
        && !element.closest('[hidden], [inert]')
        && element.getClientRects().length > 0
      ));

      const trapMenuFocus = (event) => {
        const focusable = getFocusableElements();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const focusOutside = !shell.contains(document.activeElement);
        if (event.shiftKey && (document.activeElement === first || focusOutside)) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && (document.activeElement === last || focusOutside)) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      };

      const setDesktopShopOpen = (isOpen) => {
        if (!desktopShopToggle || !desktopShopMenu) return;
        if (isOpen && window.MarmeladeFlyout && !window.MarmeladeFlyout.dismissForHeader()) return;
        desktopShopToggle.setAttribute('aria-expanded', String(isOpen));
        desktopShopMenu.hidden = !isOpen;
      };

      desktopShop?.addEventListener('mouseenter', () => setDesktopShopOpen(true));
      desktopShop?.addEventListener('mouseleave', () => setDesktopShopOpen(false));
      desktopShop?.addEventListener('focusout', (event) => {
        if (!(event.relatedTarget instanceof Node) || !desktopShop.contains(event.relatedTarget)) {
          setDesktopShopOpen(false);
        }
      });
      desktopShopToggle?.addEventListener('click', () => setDesktopShopOpen(true));

      const openMenu = () => {
        document.querySelector('marmelade-ajax-cart')?.close({ immediate: true });
        window.clearTimeout(closeTimer);
        menu.classList.remove('is-closing');
        menu.hidden = false;
        isolateBackground();
        document.body.classList.add('header-menu-is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', closeLabel);
        window.requestAnimationFrame(() => {
          if (toggle.getAttribute('aria-expanded') === 'true') getFocusableElements().find((element) => menu.contains(element))?.focus({ preventScroll: true });
        });
      };

      const closeMenu = ({ restoreFocus = false, immediate = false } = {}) => {
        if (menu.hidden) return;
        window.clearTimeout(closeTimer);
        document.body.classList.remove('header-menu-is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', openLabel);
        menu.classList.add('is-closing');
        const finishClose = () => {
          menu.hidden = true;
          menu.classList.remove('is-closing');
          restoreBackground();
          if (restoreFocus) toggle.focus();
        };
        if (immediate) finishClose();
        else closeTimer = window.setTimeout(finishClose, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 170);
      };

      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') closeMenu();
        else openMenu();
      });
      cart?.addEventListener('click', () => closeMenu({ immediate: true }));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeMenu({ restoreFocus: true });
        if (event.key === 'Tab' && toggle.getAttribute('aria-expanded') === 'true') trapMenuFocus(event);
        if (event.key === 'Escape' && desktopShopToggle?.getAttribute('aria-expanded') === 'true') {
          setDesktopShopOpen(false);
          desktopShopToggle.focus();
        }
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024 && toggle.getAttribute('aria-expanded') === 'true') closeMenu();
        if (window.innerWidth < 1024) setDesktopShopOpen(false);
      });
    });
  };

  const initialize = () => {
    initializeHeaders();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initializeHeaders(event.target));
})();
